<script>
	const http = require('core/http');
	const scrollManager = require('ui/core/scrollManager');
	const Q = require('q');
	const poll = require('modules/poll');
	const model = require('model/model');

	const { onWeeblyLinkClick } = require('utilities/weeblyUtilities');

	const analyticsUtilities = require('utilities/analyticsUtilities');
	const fireEvent = analyticsUtilities.fireEvent;
	const { VIDEO_PLAY, VIDEO_PAUSE, VIDEO_COMPLETE, PAGE_VIEW } = analyticsUtilities.events;

	const eventMap = {
		[VIDEO_PLAY]: true,
		[VIDEO_PAUSE]: true,
		[VIDEO_COMPLETE]: true
	};
	const pageCache = {};

	const NO_PAYWALL_PATHS = {
		'/alignments.html': true,
		'/whole-phonics.html': true,
		'/ckla.html': true,
		'/ckla-fl.html': true,
		'/differentiation-tools.html': true,
		'/introduction-to-readworks.html': true,
		'/build-background-knowledge.html': true,
		'/grow-vocabularies.html': true,
		'/develop-comprehension-strategies.html': true
	};

	const NEW_WINDOW_PATHS = {
		'/ngss': {
			hrefPattern: '/article'
		},
		'/book-studies': {
			hrefPattern: '/article'
		},
		'/book-studies-ms': {
			hrefPattern: '/article'
		}
	};

	module.exports = {
		components: {
			'load-mask': require('components/load-mask.vue').default,
			paywall: require('components/paywall.vue').default
		},
		props: {
			path: {
				default: ''
			},
			rootPath: {
				default: '/'
			},
			weeblyRootPath: {
				default: '/'
			},
			eventData: {
				default: {}
			}
		},
		modelData: ['userContext'],
		data() {
			return {
				loading: false,
				hideIFrame: false,
				slowPoll: null
			};
		},
		computed: {
			userIsUnauthenticated() {
				let userContext = this.userContext;
				return !userContext || userContext.classCode;
			},
			isRootPath() {
				return this.path === '' || this.path === '/';
			},
			showPaywall() {
				let path = this.path;
				let noPaywallPath = NO_PAYWALL_PATHS[path];
				let isRootPath = this.isRootPath;
				let userIsUnauthenticated = this.userIsUnauthenticated;

				return !noPaywallPath && !isRootPath && userIsUnauthenticated;
			}
		},
		methods: {
			fetchPage(path) {
				let iframe = this.$refs.contentFrame;
				let weeblyRootPath = this.weeblyRootPath;
				this.loading = true;
				path = path.replace('.html', '');
				if (!path || path === '/' || path.replace('/', '') === weeblyRootPath.replace('/', '')) {
					path = weeblyRootPath;
				} else {
					path += '.html';
				}

				clearInterval(this.slowPoll);
				let prms = null;

				if (pageCache[path]) {
					prms = Q(pageCache[path]);
				} else {
					prms = http.get('/weebly' + path).then(r => r && r.text);
				}
				prms.then(html => {
					this.hideIFrame = true;
					let contentWindow = iframe.contentWindow;
					if (contentWindow) {
						html = html.replace(new RegExp(/\/\/cdn2.editmysite.com\/js\/site\/main-customer-accounts-site.js\?buildTime=[0-9]+/), '');
						html = html.replace(new RegExp(/\/files\/theme\/plugins.js\?[0-9]+/), '');
						html = html.replace(new RegExp(/\/files\/theme\/custom.js\?[0-9]+/), '');
						html = html.replace(new RegExp(/\/files\/templateArtifacts.js\?[0-9]+/), '');
						html = html.replace(new RegExp(/UA-[0-9]+-[0-9]/g), '');
						iframe.contentWindow.contents = html;
					}
					iframe.src = 'javascript:window["contents"]';
					pageCache[path] = html;
					fireEvent(PAGE_VIEW, this.eventData || {});
				});
			},
			parseProtectedEmail(str) {
				const xorComparator = parseInt(str.slice(0, 2), 16);
				let email = '';

				for (let i = 2; i < str.length; i += 2) {
					const xorSegment = parseInt(str.slice(i, i + 2), 16);
					// eslint-disable-next-line no-bitwise
					email += String.fromCharCode(xorSegment ^ xorComparator);
				}

				return email;
			},
			onLoad() {
				let iframe = this.$refs.contentFrame;
				let body = iframe.contentDocument.body;
				let head = iframe.contentDocument.head;
				let domain = 'https://about.readworks.org';
				let style = document.createElement('style');
				style.innerHTML = `
				html {
					overflow-x: hidden;
					overflow-y: hidden;
					background-color: #FFF;
				}

				.wsite-background, .wsite-header-section {
					background: url(${domain}/theme/images/default-bg.jpg?1616077077) no-repeat center center;
					background-size: cover;
				}

				.blogCommentWrap:before {
					content: '';
					position: absolute;
					top: 0;
					left: 0;
					width: 50px;
					height: 50px;
					background: #059fc5 url(${domain}/theme/images/comment.png?1616077077) no-repeat center center;
				}
			`;

				if (iframe && body && body.innerHTML) {
					//Remove weebly header and footer
					let menus = $('div#wsite-menus > .wsite-menu-wrap', body).remove();
					$('div#banner-wrap #header-wrap', body).remove();
					$('div#footer-wrap', body).remove();

					// Replace all URLs with absolute instead of relative
					//// Main css URL
					let mainCss = $('link[title=wsite-theme-css]', head);
					mainCss.attr('href', domain + mainCss.attr('href'));

					//// JS
					$('script[src*="/files/theme"]', body).each((idx, s) => {
						$(s).remove();
					});
					//// img src references
					$('img', body).each((idx, img) => {
						let src = img.getAttribute('src');
						if (src.indexOf('//www.weebly.com/') !== 0) {
							img.setAttribute('src', domain + src);
						}
					});
					//// embedded 'style' properties
					$('*[style]', body).each((idx, el) => {
						let elStyle = el.style;
						if (elStyle && elStyle.cssText.indexOf('url("') !== -1) {
							elStyle.cssText = elStyle.cssText.replace('url("', 'url("' + domain);
						}
					});

					body.querySelectorAll('.__cf_email__').forEach(element => {
						const emailString = this.parseProtectedEmail(element.dataset.cfemail);
						element.insertAdjacentText('beforebegin', emailString);
						element.remove();
					});

					body.appendChild(style);

					let vimeoAPI = document.createElement('script');
					vimeoAPI.setAttribute('src', 'https://player.vimeo.com/api/player.js');
					body.appendChild(vimeoAPI);

					poll(() => {
						this.loading = false;
						this.hideIFrame = false;
						if (this.setFrameHeight()) {
							this.attachEvents();
							this.checkHash();
							return true;
						}
						return false;
					}, 50);

					clearInterval(this.slowPoll);
					this.slowPoll = poll(
						() => {
							if (this.setFrameHeight()) {
								return true;
							}
							return false;
						},
						1000,
						true
					);
					this.processWeeblyMenus(menus);
				}
			},
			setFrameHeight() {
				let iframe = this.$refs.contentFrame;
				if (iframe && iframe.contentDocument && iframe.contentDocument.body && iframe.contentDocument.body.scrollHeight) {
					let height = iframe.contentDocument.body.scrollHeight;
					if (this.showPaywall) {
						height = 500;
					}
					$(iframe).css('height', height + 'px');
					return true;
				}
				return false;
			},
			attachEvents() {
				let iframe = this.$refs.contentFrame;
				let body = iframe.contentDocument.body;
				let scriptBody = `
				function round(value, digits = 2, type = 'floor') {
					if (typeof value === 'number') {
						let multiplier = Math.pow(10, digits);
						return Math[type](value * multiplier) / multiplier;
					}
					return null;
				}
				function captureEvent(type, id, event, startTime) {
					let name = 'VIDEO_' + type.toUpperCase();
					let timeSpent = undefined;
					let position = event ? event.seconds : null;

					if (typeof startTime === 'number' && position) {
						timeSpent = round(position - startTime);
					}

					let eventData = {
						duration: event.duration,
						percent: event.percent,
						seconds: event.seconds,
						timeSpent,
						id: id
					}
					let message = {
						type: 'vimeo-event',
						event: name,
						eventData: eventData
					}
					parent.postMessage(message, '*');
				}
				function attachPlayers() {
					$('iframe[src*="vimeo.com"]')
						.each((idx, el) => {
							let vimeoIdRegex = /\\/video\\/([0-9]+)/;
							let src = el.src;
							let player = new Vimeo.Player(el);
							let match = src ? src.match(vimeoIdRegex) : null;
							let startTime = null;

							if (match && match[1]) {
								let id = match[1];

								player.on('play', function(e) {
									startTime = e.seconds;
									captureEvent('play', id, e);
								});
								player.on('pause', function(e) {
									captureEvent('pause', id, e, startTime);
									startTime = null;
								});
								player.on('ended', function(e) {
									captureEvent('complete', id, e, startTime);
									startTime = null;
								});
							}
						});
				};
				var vimeoInterval = setInterval(function() {
					if (window.Vimeo) {
						attachPlayers();
						clearInterval(vimeoInterval);
					}
				}, 100);
			`;

				if (iframe && body && body.innerHTML) {
					$('a', body).each((idx, el) => {
						$(el).on('click', e => {
							this.onLinkClick(e);
						});
					});

					$('.accordion.accordion--simple', body).on('click', e => {
						let el = e.currentTarget;
						$('.accordion__item', el).toggleClass('active');
					});

					window.addEventListener('message', this.onMessage);

					let vimeoScript = document.createElement('script');
					vimeoScript.append(scriptBody);
					body.append(vimeoScript);
				}
			},
			onLinkClick(e) {
				const rootPath = this.rootPath;
				const path = this.path;
				const href = e && e.currentTarget ? e.currentTarget.getAttribute('href') : null;
				let newWindow = false;

				e.stopPropagation();
				e.preventDefault();

				if (path && href) {
					newWindow = Object.keys(NEW_WINDOW_PATHS).some(p => {
						if (path.indexOf(p) !== -1) {
							const pathInfo = NEW_WINDOW_PATHS[p];
							if (pathInfo && pathInfo.hrefPattern) {
								// If hrefPattern, require a match
								return href.indexOf(pathInfo.hrefPattern) !== -1;
							} else {
								// If no hrefPattern, assume all links on page match
								return true;
							}
						}
						return false;
					});
				}

				onWeeblyLinkClick(e.currentTarget, rootPath, newWindow);
			},
			onMessage(message) {
				let data = message.data;
				if (data && data.type === 'vimeo-event' && eventMap[data.event]) {
					this.onVideoEvent(data.event, data.eventData);
				}
			},
			onVideoEvent(event, data) {
				let id = data.id;
				let length = data.duration;
				let duration = data.timeSpent;
				let position = data.seconds;
				let type = 'vimeo';
				let eventData = { id, type, position, length, duration };

				fireEvent(event, eventData);
			},
			checkHash() {
				let iframe = this.$refs.contentFrame;
				let body = iframe ? iframe.contentDocument.body : null;
				let hash = window.location.hash;
				if (hash && body) {
					poll(
						() => {
							let query = 'a[name=' + hash.replace('#', '') + ']';
							let el = null;
							try {
								el = $(query, body).get(0);
							} catch (e) {
								el = null;
							}
							// console.log(query);
							if (el) {
								// console.log('found el');
								scrollManager(el, {
									duration: 500,
									priority: 0
								});
								return true;
							}
							return false;
						},
						500,
						false,
						5000
					);
				}
			},
			processWeeblyMenus(menuDom) {
				// console.log(menuDom);
				let menus = {};
				if (menuDom && menuDom.length) {
					menuDom.each((idx, el) => {
						// console.log(el);
						let key = null;
						let links = [];
						$(el)
							.find('> ul.wsite-menu > li.wsite-menu-subitem-wrap')
							.each((itemIdx, subEl) => {
								if (itemIdx === 0) {
									key = $(subEl).find('.wsite-menu-title').text().trim();
								} else {
									links.push(subEl);
								}
							});
						if (key && links.length) {
							menus[key] = this.convertMenuDomToJSON(links);
						}
					});
					// console.log(menus);
					model.set('weeblyMenus', menus);
				}
			},
			convertMenuDomToJSON(nodes) {
				let links = [];
				// let rootPath = this.rootPath;

				$(nodes).each((idx, node) => {
					let anchorNode = $(node).find('> a').get(0);
					let href = anchorNode ? anchorNode.getAttribute('href') : '';
					let label = $(node).find('> a > .wsite-menu-title').text().trim();
					let subEls = $(node).find('> .wsite-menu-wrap > .wsite-menu').children();
					let link = { label, href };
					// console.log(title, href);

					if (subEls && subEls.length) {
						// console.log('kids', subEls);
						link.navItems = this.convertMenuDomToJSON(subEls);
					}

					links.push(link);
				});
				// console.log('menu', links);
				return links;
			}
		},
		watch: {
			path(value) {
				this.fetchPage(value);
			}
		},
		beforeDestroy() {
			window.removeEventListener('message', this.onMessage);
			if (this.hashPoll) {
				clearInterval(this.hashPoll);
			}
		},
		mounted() {
			this.fetchPage(this.path);
			let lastHash = null;
			this.hashPoll = poll(() => {
				let hash = window.location.hash;
				if (hash && hash !== lastHash) {
					this.checkHash();
					lastHash = hash;
				}
			}, 500);
		}
	};
</script>
<style lang="scss">
	.weebly-iframe {
		position: relative;

		.article-paywall {
			margin-bottom: 2rem;

			.article-fader {
				top: -12rem;
				height: 12rem;
			}
		}

		iframe {
			width: 100%;
			border: none;

			&.hidden {
				display: none;
				height: 50px;
			}
		}
	}
</style>
<template>
	<div class="weebly-iframe">
		<iframe
			ref="contentFrame"
			:class="{
				hidden: hideIFrame
			}"
			@load="onLoad"></iframe>
		<load-mask v-if="loading"></load-mask>
		<paywall v-else-if="showPaywall"></paywall>
	</div>
</template>
